module.exports = __webpack_public_path__ + "static/media/menuHamburger.dc00ab4f.svg";